<template>
  <div class='d-flex align-center justify-center'>
    <v-progress-circular v-if="loading" :size="15" :width="1" indeterminate/>
    <v-icon v-else-if="!isAdminUser && isHasSameClinic" size="24" :class="iconColor" @click="toggleUser" :disabled='mergeItemLoading'>{{'mdi-merge'}}</v-icon>
  </div>
</template>

<script>
  import api from '@/api/api';

  export default {
    name: 'UsersMergeIcon',

    data() {
      return {
        loading: false
      };
    },

    props: {
      userData: {
        type: Object,
      },
      mergeData: {
        type: Array,
      },
      mergeItemLoading: {
        type: Boolean
      }
    },

    computed: {
      iconColor: function() {
        if (this.mergeData.findIndex(mergeItem => this.userData.userId === mergeItem.userId) >= 0) {
          return 'red--text text--lighten-2'
        } else {
          return 'grey--text text--darken-2'
        }
      },
      isHasSameClinic: function() {
        if (this.userData.clinicIds.length <= 0) return false;
        if (this.mergeData.length <= 0) return true;

        let isExist = false;
        this.mergeData.forEach((mergeItem) => {
          if (mergeItem.clinicIds.some(item => this.userData.clinicIds.includes(item))) {
            isExist = true;
          }
        });
        return isExist;
      },
      isAdminUser: function() {
        const checkRoles = ["Admin", "Surgeon"];
        return this.userData.roles.some(role => checkRoles.includes(role));
      }
    },

    methods: {
      toggleUser: async function() {
        let isExist = this.mergeData.findIndex(mergeItem => this.userData.userId === mergeItem.userId);
        if (isExist >= 0) {
          this.$emit('toggleMergeUser', this.userData);
        } else {
          try {
            this.loading = true;
            this.$emit('updateMergeItemLoading', true);
            let newUserData = await api.getSingleUser(this.userData.userId);
            newUserData.data.clinicIds = this.userData.clinicIds || [];
            this.$emit('toggleMergeUser', newUserData.data);
          } finally {
            this.loading = false;
            this.$emit('updateMergeItemLoading', false);
          }
        }
      }
    }
  };
</script>
